import React, { useMemo } from "react";

import { isTestCasePolicy, Policy } from "@design-controls/types";
import { QFormControl, QMultiSelect } from "@qualio/ui-components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  policies: Policy[];
};

export const TestCaseType: React.FC<Props> = ({ policies }) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return policies
      .filter(isTestCasePolicy)
      .map((config) => ({ label: config.label, value: config.type }));
  }, [policies]);

  return (
    <Controller
      name="type"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t("filters.testType")}>
          <QMultiSelect
            value={value}
            onChange={(selectedItem) =>
              onChange(selectedItem.map((item) => item.value))
            }
            options={options}
          />
        </QFormControl>
      )}
    />
  );
};
